import { Component, OnInit, Inject, ElementRef } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'label[iccLabel]',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss']
})
export class LabelComponent implements OnInit {

  constructor(@Inject(ElementRef) private readonly elementRef: ElementRef<HTMLElement>) {}

  ngOnInit(){
    this.handleClasses();
    
  }

  protected handleClasses() {

    if(this.elementRef?.nativeElement){
    
      if(this.elementRef.nativeElement?.parentElement){
        const classes = this.elementRef.nativeElement?.parentElement?.classList;
        if(classes.value.includes('icc-form-field-frame')){
          (this.elementRef.nativeElement as HTMLElement).classList.add('in-form-field');
        }
      }
      
    }

  }

}
